

export default {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  // async downloadTeacherDailyAttendanceReport(context, payload) {
  //   const date = payload.date ?? dayjs().format();
  //
  //   try {
  //     ApiService.setHeader();
  //     const response = await ApiService.query(
  //       "school/attendance/teacher/report",
  //       {
  //         responseType: "blob",
  //         params: {
  //           date: date,
  //           type: payload.type,
  //         },
  //       }
  //     );
  //
  //     SchoolReportDownloadService.processDownload(
  //       response.data,
  //       "Teacher Daily Attendance - "
  //     );
  //
  //     return response;
  //   } catch (e) {
  //     console.error(e);
  //     throw e;
  //   }
  // },
};
